import type { FrontifyImageContent } from '@/contentful/contentful.types';
import type { PaidLanderCf } from '@/types';

export type PaidLanderFields = Omit<
  PaidLanderCf['fields'],
  | 'firstStepImage'
  | 'secondStepImage'
  | 'successScreenImage'
  | 'failureScreenImage'
> & {
  firstStepImage?: FrontifyImageContent[];
  secondStepImage?: FrontifyImageContent[];
  successScreenImage?: FrontifyImageContent[];
  failureScreenImage?: FrontifyImageContent[];
};

export type PaidLanderType = Omit<PaidLanderCf, 'fields'> & {
  fields: PaidLanderFields;
};

export interface PaidLanderProps {
  content: PaidLanderType;
}

export enum PaidLanderSteps {
  QUALIFY = 'Qualify',
  SUBMIT = 'Submit',
  SUCCESS = 'Success',
  FAILURE = 'Failure',
}
